/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").classList.add('active');
    // document.querySelector('#header').classList.remove('bg');
    document.querySelector("#headerMenu")?.classList.remove('active');
    document.querySelector("#headerClose")?.classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}

// // dialog close event
// document.querySelector("#slider").addEventListener("close", async function () {
//     document.querySelector("body").classList.remove("noScroll");
// });

// close nav
async function closeNav() {
    document.querySelector("#slider").classList.remove('active');
    // document.querySelector('#header').classList.remove('bg');
    document.querySelector("#headerMenu")?.classList.add('active');
    document.querySelector("#headerClose")?.classList.remove('active');
    document.querySelector("body").classList.remove("noScroll");
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// // register dialog
// dialogPolyfill.registerDialog(document.querySelector("#slider"));

// header scroll change background

// add background when header hits top
const header = document.querySelector('#header');
const headerLogo = document.querySelector('#headerLogo');
const headerLogoAlt = document.querySelector('#headerLogoAlt');
window.addEventListener('scroll', () => {
    const headerTop = header.getBoundingClientRect().top - 12;
    if (headerTop <= 1) {
        header.classList.add('bg');
        headerLogo.classList.remove('active');
        headerLogoAlt.classList.add('active');

    } else {
        header.classList.remove('bg');
        headerLogo.classList.add('active');
        headerLogoAlt.classList.remove('active');
    }
});

// toggle open header search

const searchButton = document.querySelector('#headerRightIconsSearch');
const headerSearch = document?.querySelector('#headerSearch');
const headerSearchClose = document?.querySelector('.headerSearchFormClose');


if (headerSearch) {
    searchButton.addEventListener('click', function () {
        const query = headerSearch.querySelector('#headerSearchFormQuery');
        query.value = "";
        const open = headerSearch.classList.toggle('active');
        searchButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        // focus inside the tap gesture so phones raise the keyboard
        if (open) { query.focus({ preventScroll: true }); } else { query.blur(); }
    });
    searchButton.setAttribute('aria-expanded', 'false');
    searchButton.setAttribute('aria-controls', 'headerSearch');

// populate the search input with the clicked item (a tap, or Enter / Space from the keyboard)
    headerSearch.querySelectorAll('.headerSearchRecsItemGroupExample').forEach(example => {
        const pick = function () {
            const searchInput = headerSearch.querySelector('#headerSearchFormQuery');
            searchInput.value = example.textContent.trim();   /* as written, not the capitals the CSS shows */
            headerSearch.querySelector('#headerSearchForm').submit();
        };
        example.addEventListener('click', pick);
        example.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
        });
    })

// close the search panel: the X, Escape, or a click anywhere outside it (24 Sep 2026)
    const closeSearch = function (returnFocus) {
        if (!headerSearch.classList.contains('active')) {
            return;
        }
        headerSearch.classList.remove('active');
        headerSearch.querySelector('#headerSearchFormQuery').value = "";
        searchButton.setAttribute('aria-expanded', 'false');
        if (returnFocus) { searchButton.focus({ preventScroll: true }); }
    };
    headerSearchClose.addEventListener('click', function () { closeSearch(true); });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && headerSearch.classList.contains('active')) { closeSearch(true); }
    });
    document.addEventListener('click', function (e) {
        if (!headerSearch.classList.contains('active')) { return; }
        if (headerSearch.contains(e.target) || searchButton.contains(e.target)) { return; }
        closeSearch(false);
    });
}
